export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Herbs & Spices",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/armenian.jpg",
      title: "92 Armenian Sdn Bhd",
      subtitle: "Stewed birdnest flat price at RM88 storewide",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-92-armenian-sdn-bhd"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/yew-chian-haw.jpeg",
      title: "Yew Chian Haw",
      subtitle: "Chinese herbs as low as RM1.68",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-yew-chian-haw"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/tropical-spice-garden.jpg",
      title: "Tropical Spice Garden",
      subtitle: "Tropical spices as low as RM7.00",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-tropical-spice-garden"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/anthene-spices.jpg",
      title: "Athene Spices",
      subtitle: "Penang spices starting from RM20.00",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-athene-spices"
    }
  ],
}
